export const ROUTE = {
  LOGIN: {
    PATH: '/login',
    TITLE: 'login',
  },
  FORGOT_PASSWORD: {
    PATH: '/forgot-password',
    TITLE: 'forgotPassword',
  },
  VERIFY_OTP: {
    PATH: '/otp',
    TITLE: 'verifyOTP',
  },
  RESET_PASSWORD: {
    PATH: '/reset-password',
    TITLE: 'resetPassword',
  },
}
